import apiGetRequest from "./base/api-get-request";

const getPublicDataValidationTable = () =>
  apiGetRequest("/snowflake-validation-table")();

const getPublicDataValidationGraph = () =>
  apiGetRequest("/snowflake-validation-graph")();

export { getPublicDataValidationTable, getPublicDataValidationGraph };
